export default function forwardToURL(url) {
  // Func to add a 1 sec delay before forwarding on.
  setTimeout(() => {
    window.location = url;
  }, 1000);
}
